import { Link, useLocation } from 'react-router'
import { AspectRatio, Image } from '@mantine/core'
import { News } from './api'
import NewsPlaceholder from '../assets/news_placeholder.png'
import classes from './News.module.css'
import { Typography } from '../common/typography'
import clsx from 'clsx'

export default function NewsCard({
  news,
  className,
}: {
  news: News
  className?: string
}) {
  const location = useLocation()

  return (
    <Link
      to={`/news/${news.news_id}`}
      state={{ from: location }}
      className={classes.newsCardLink}
    >
      <div className={clsx(className, classes.newsCard)}>
        <AspectRatio ratio={16 / 9}>
          <Image
            src={news.image.main || NewsPlaceholder}
            alt={news.title}
            w="100%"
            h="100%"
          />
        </AspectRatio>
        <div className={classes.newsDescription}>
          <Typography level={3} fw={500} lh="125" className={classes.newsTitle}>
            {news.title}
          </Typography>
          <p>{new Date(news.created_at).toLocaleDateString('en-GB')}</p>
        </div>
        <div className={classes.newsDetails} />
      </div>
    </Link>
  )
}
